<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3"
    >
      <template v-if="domains.total != null"
        ><h1 class="h2">Found {{ domains.total }} domains</h1></template
      >
      <template v-else> <h1 class="h2">Searching...</h1></template>
    </div>
    <div class="table-responsive">
      <DomainListing
        v-bind="{ q: qs }"
        v-on:updateDomainDetails="updateDomainDetails"
      />
    </div>
  </div>
</template>

<script>
import DomainListing from "../components/DomainsListing";

export default {
  components: { DomainListing },
  data() {
    return {
      domains: {
        total: null,
        offset: null,
        q: null,
      },
      qs: null,
    };
  },
  created() {
    this.qs = this.$route.query.qs;
  },
  methods: {
    updateDomainDetails(details) {
      this.domains = details;
      if (details.total === 1) {
        this.$router.push({
          name: "domain-details",
          params: { domain: details.items[0].domain },
        });
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.qs = this.$route.query.qs;
  },
};
</script>
